export default __webpack_public_path__ + "static/media/welcome.660b8154.jpg";